import tagularEvent from 'js/services/tagularEvent'

const selectedBanks = []

const compareButton = document.querySelector(
  '[data-js-selector="compare-bar__compare-button"]'
)

const compareBarInfoText = document.querySelector(
  '[data-js-selector="compare-bar__info-text"]'
)

const compareHubBankList = document.querySelector(
  '.bank-review-hub-card__wrapper'
)

// Could get rid of this
const checkboxLabels = Array.from(
  compareHubBankList.querySelectorAll(
    '[data-js-selector="hub-card-compare-checkbox"]'
  )
)

const selectedBankBlocks = Array.from(
  document.querySelectorAll('[data-js-selector="bank-selection"]')
)

const compareBar = document.querySelector('[data-js-selector="compare-bar"')

// --------------[Event Bindings]------------------- //

window.addEventListener('load', () => {
  sendFormStartedEvent()
  bindCheckboxClick()
  bindCompareButtonClick()
})

function bindCompareButtonClick() {
  compareButton.addEventListener('mouseup', sendFormSubmittedEvent)
}

function bindCheckboxClick() {
  compareHubBankList.addEventListener('mouseup', e => {
    const checkboxLabel = e.target.closest(
      '[data-js-selector="hub-card-compare-checkbox"]'
    )

    // Using event delegation so if it's NOT a checkbox click, do nothing
    if (!checkboxLabel) {
      return
    }

    const { dataset } = checkboxLabel
    checkboxLabel.toggleAttribute('checked')

    const bank = {
      name: dataset.advertiserName,
      logo: dataset.advertiserLogo,
      slug: dataset.advertiserSlug
    }

    const indexOfSelectedBank = bankSelectionIndex(bank.slug)
    const isAlreadySelected = indexOfSelectedBank > -1

    if (!isAlreadySelected) {
      selectBank(bank)
    } else {
      deselectBank(bank, indexOfSelectedBank)
    }

    handleComparisonLink()
  })
}

// --------------[Tracking]------------------- //

function sendFormStartedEvent() {
  tagularEvent('FormStarted', {
    formContext: {
      formType: 'comparison',
      formName: 'deposits lender compare',
      formId: window.purchaseId
    },
    correlationId: window.purchaseId + '(0)'
  })
}

function sendFormSubmittedEvent() {
  const bankSelectionMetadata = mapBankSelectionMetadata()

  tagularEvent('FormSubmitted', {
    formContext: {
      formType: 'comparison',
      formName: 'deposits lender compare'
    },
    correlationId: window.purchaseId + '(0)',
    field: bankSelectionMetadata
  })
}

function mapBankSelectionMetadata() {
  return selectedBanks.map((bank, index) => {
    return {
      fieldType: 'Bank Name',
      fieldName: `Lender ${index + 1}`,
      fieldValue: bank.name,
      fieldLabel: `Lender ${index + 1}`
    }
  })
}

// --------------[Bank Selection]------------------- //

function selectBank(bank) {
  storeBankInfo(bank)
  toggleCompareBar()
  toggleCheckboxStatus()
  setBankImage(bank.logo)
  bindBankImageHandler(bank.logo)
}

function deselectBank(bank, indexOfSelectedBank) {
  removeBankInfo(indexOfSelectedBank)
  toggleCompareBar()
  toggleCheckboxStatus()
  unbindBankImageHandler(bank.logo)
  removeBankImage(bank.logo)
}

function storeBankInfo(bank) {
  if (selectedBanks.length < 2) {
    selectedBanks.push(bank)
  }
}

function bankSelectionIndex(lookupString) {
  const index = selectedBanks.findIndex(x => {
    return x.slug === lookupString || lookupString.includes(x.logo)
  }, 1)
  return index
}

function removeBankInfo(indexOfSelectedBank) {
  if (indexOfSelectedBank > -1) {
    selectedBanks.splice(indexOfSelectedBank, 1)
  }
}

function toggleCompareBar() {
  const selectedBankCount = selectedBanks.length

  if (selectedBankCount === 2) {
    return
  }

  if (selectedBankCount === 0) {
    return compareBar.classList.remove('--open')
  }

  if (selectedBankCount === 1) {
    return compareBar.classList.add('--open')
  }
}

// --------------[Checkboxes]------------------- //

function toggleCheckboxStatus() {
  if (selectedBanks.length === 1) {
    enableCheckboxes()
  } else if (selectedBanks.length === 2) {
    disableCheckboxes()
  }
}

function enableCheckboxes() {
  checkboxLabels.forEach(label => {
    label.classList.remove('--is-disabled')
    label.childNodes[1].removeAttribute('disabled')
  })
}

function disableCheckboxes() {
  const unselectedCheckboxLabels = checkboxLabels.filter(label => {
    return !label.hasAttribute('checked')
  })

  unselectedCheckboxLabels.forEach(label => {
    label.classList.add('--is-disabled')
    label.childNodes[1].setAttribute('disabled', 'disabled')
  })
}

// --------------[Bank Images]------------------- //

function setBankImage(logo) {
  const bankSelection = selectedBankBlocks.find(bankSelection => {
    return bankSelection.className.includes('--inactive')
  })

  const bankSelectionImg = bankSelection.querySelector('img')

  bankSelection.classList.remove('--inactive')
  bankSelectionImg.setAttribute('src', logo)
  bankSelectionImg.classList.remove('--hidden')
}

function removeBankImage(logo) {
  const bankSelection = selectedBankBlocks.find(bankSelection => {
    const logoUrl = bankSelection.querySelector('img').src
    return logoUrl.includes(logo)
  })

  const bankSelectionImg = bankSelection.querySelector('img')

  bankSelection.classList.add('--inactive')
  bankSelectionImg.setAttribute('src', '')
  bankSelectionImg.classList.add('--hidden')
}

function bindBankImageHandler(logoUrl) {
  const bankSelection = findBankSelectionByLogoUrl(logoUrl)
  bankSelection.addEventListener('mouseup', bankImageClickHandler)
}

function unbindBankImageHandler(logoUrl) {
  const bankSelection = findBankSelectionByLogoUrl(logoUrl)
  bankSelection.removeEventListener('mouseup', bankImageClickHandler)
}

function findBankSelectionByLogoUrl(logoUrl) {
  return selectedBankBlocks.find(bankSelection => {
    const matchedLogoUrl = bankSelection.querySelector('img').src
    return matchedLogoUrl.includes(logoUrl)
  })
}

function bankImageClickHandler(e) {
  const bankSelection = e.currentTarget
  const bankSelectionImg = bankSelection.querySelector('img')
  const logoUrl = bankSelectionImg.src

  const indexOfSelectedBank = bankSelectionIndex(logoUrl)

  removeBankInfo(indexOfSelectedBank)
  toggleCompareBar()
  toggleCheckboxStatus()
  removeBankImage(logoUrl)
  uncheckCheckbox(logoUrl)
  handleComparisonLink()
  bankSelection.removeEventListener('mouseup', bankImageClickHandler)
}

function uncheckCheckbox(logoUrl) {
  const matchedCheckboxLabel = checkboxLabels.find(label => {
    return logoUrl.includes(label.dataset.advertiserLogo)
  })

  const matchedCheckbox = matchedCheckboxLabel.querySelector('input')
  matchedCheckboxLabel.toggleAttribute('checked')
  matchedCheckbox.checked = false
}

// --------------[Compare Link]------------------- //

function handleComparisonLink() {
  const selectedBankCount = selectedBanks.length

  if (selectedBankCount === 0) {
    return
  }

  if (selectedBankCount == 1) {
    disableCompareLink()
    compareBarInfoText.innerHTML = 'Select another bank to compare'
  }

  if (selectedBankCount == 2) {
    const compareLink = buildCompareLink()
    enableCompareLink(compareLink)
    compareBarInfoText.innerHTML = 'Select a bank again to remove'
  }
}

function buildCompareLink() {
  const selectedBankSlugs = selectedBanks.map(bank => bank.slug).sort()
  return `/banking/comparison/${selectedBankSlugs.join('-vs-')}/`
}

function enableCompareLink(compareLink) {
  compareButton.href = compareLink
  compareButton.classList.remove('--is-disabled')
}

function disableCompareLink() {
  compareButton.href = ''
  compareButton.classList.add('--is-disabled')
}
